import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col',
    searchContainer: 'p-4 pb-[32px]',
    categories: 'bg-bg-page py-4',
    info: 'flex flex-col gap-4 p-6',
    infoItem: 'hover:bg-bg-page heading-s cursor-pointer rounded-full px-1',
    contact: 'flex flex-col gap-5 p-6 pt-1',
    contactDetails: 'flex flex-col',
    contactPhone: 'heading-2xl',
    contactHours: 'heading-s',
    contactEmail: 'heading-lg'
  },
  variants: {
    color: {
      primary: 'text-black'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
